import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteWaitingUser = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.USER.DELETE_WAITING_USER,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteWaitingUser
